// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyEditV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  RentalManagerModularListingProgressV2WebDto,
  UpdateIsApplicationsAcceptedV2RequestDto,
  UserPropertyEditAdditionalEmailV2RequestDto,
  UserPropertyEditAgentLicenseTypeV2RequestDto,
  UserPropertyEditClearPropertyOnlyV2RequestDto,
  UserPropertyEditContactHoursResponseV2WebDto,
  UserPropertyEditContactHoursV2RequestDto,
  UserPropertyEditContactNameV2RequestDto,
  UserPropertyEditDisplayTotalMonthlyPriceWithFeeV2RequestDto,
  UserPropertyEditEmailResponseV2WebDto,
  UserPropertyEditEmailV2RequestDto,
  UserPropertyEditForRentByV2RequestDto,
  UserPropertyEditFullDescriptionV2RequestDto,
  UserPropertyEditHidePhoneV2RequestDto,
  UserPropertyEditHideStreetAddressV2RequestDto,
  UserPropertyEditIsBrokerExclusiveV2RequestDto,
  UserPropertyEditIsIncomeRestrictedV2RequestDto,
  UserPropertyEditIsRentersInsuranceRequiredV2RequestDto,
  UserPropertyEditLaundryV2RequestDto,
  UserPropertyEditLeaseDurationV2RequestDto,
  UserPropertyEditLeaseTermsV2RequestDto,
  UserPropertyEditModularListingProgressV2RequestDto,
  UserPropertyEditNameV2RequestDto,
  UserPropertyEditParkingDescriptionV2RequestDto,
  UserPropertyEditPetPolicyDescriptionV2RequestDto,
  UserPropertyEditPhoneResponseV2WebDto,
  UserPropertyEditPhoneV2RequestDto,
  UserPropertyEditPropertyTypeV2RequestDto,
  UserPropertyEditResponseV2WebDto,
  UserPropertyEditSecurityDepositResponseV2WebDto,
  UserPropertyEditSecurityDepositV2RequestDto,
  UserPropertyEditSetAsPropertyOnlyV2RequestDto,
  UserPropertyEditUnitsInBuildingV2RequestDto,
  UserPropertyEditVideoUrlV2RequestDto,
  UserPropertyEditWebSiteV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyEditV2WebApiHandler_additionalEmail_Path =
  '/api/web/v2/users/properties/additionalEmail';

export const RentalManagerUserPropertyEditV2WebApiHandler_additionalEmail = (
  postData: UserPropertyEditAdditionalEmailV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditAdditionalEmailV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_additionalEmail_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_agentLicenseType_Path =
  '/api/web/v2/users/properties/agentLicenseType';

export const RentalManagerUserPropertyEditV2WebApiHandler_agentLicenseType = (
  postData: UserPropertyEditAgentLicenseTypeV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditAgentLicenseTypeV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_agentLicenseType_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_clearPropertyOnly_Path =
  '/api/web/v2/users/properties/clearPropertyOnly';

export const RentalManagerUserPropertyEditV2WebApiHandler_clearPropertyOnly = (
  postData: UserPropertyEditClearPropertyOnlyV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditClearPropertyOnlyV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_clearPropertyOnly_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_contactHours_Path =
  '/api/web/v2/users/properties/contactHours';

export const RentalManagerUserPropertyEditV2WebApiHandler_contactHours = (
  postData: UserPropertyEditContactHoursV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyEditContactHoursV2RequestDto,
    UserPropertyEditContactHoursResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_contactHours_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_contactName_Path = '/api/web/v2/users/properties/contactName';

export const RentalManagerUserPropertyEditV2WebApiHandler_contactName = (
  postData: UserPropertyEditContactNameV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditContactNameV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_contactName_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_displayTotalMonthlyPriceWithFee_Path =
  '/api/web/v2/users/properties/displayTotalMonthlyPriceWithFee';

export const RentalManagerUserPropertyEditV2WebApiHandler_displayTotalMonthlyPriceWithFee = (
  postData: UserPropertyEditDisplayTotalMonthlyPriceWithFeeV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyEditDisplayTotalMonthlyPriceWithFeeV2RequestDto,
    UserPropertyEditResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_displayTotalMonthlyPriceWithFee_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_email_Path = '/api/web/v2/users/properties/email';

export const RentalManagerUserPropertyEditV2WebApiHandler_email = (
  postData: UserPropertyEditEmailV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditEmailV2RequestDto, UserPropertyEditEmailResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_email_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_forRentBy_Path = '/api/web/v2/users/properties/forRentBy';

export const RentalManagerUserPropertyEditV2WebApiHandler_forRentBy = (
  postData: UserPropertyEditForRentByV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditForRentByV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_forRentBy_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_fullDescription_Path =
  '/api/web/v2/users/properties/fullDescription';

export const RentalManagerUserPropertyEditV2WebApiHandler_fullDescription = (
  postData: UserPropertyEditFullDescriptionV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditFullDescriptionV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_fullDescription_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_hidePhone_Path = '/api/web/v2/users/properties/hidePhone';

export const RentalManagerUserPropertyEditV2WebApiHandler_hidePhone = (
  postData: UserPropertyEditHidePhoneV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHidePhoneV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_hidePhone_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_hideStreetAddress_Path =
  '/api/web/v2/users/properties/hideStreetAddress';

export const RentalManagerUserPropertyEditV2WebApiHandler_hideStreetAddress = (
  postData: UserPropertyEditHideStreetAddressV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditHideStreetAddressV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_hideStreetAddress_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_isApplicationsAccepted_Path =
  '/api/web/v2/users/properties/isApplicationsAccepted';

export const RentalManagerUserPropertyEditV2WebApiHandler_isApplicationsAccepted = (
  postData: UpdateIsApplicationsAcceptedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdateIsApplicationsAcceptedV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_isApplicationsAccepted_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_isBrokerExclusive_Path =
  '/api/web/v2/users/properties/isBrokerExclusive';

export const RentalManagerUserPropertyEditV2WebApiHandler_isBrokerExclusive = (
  postData: UserPropertyEditIsBrokerExclusiveV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditIsBrokerExclusiveV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_isBrokerExclusive_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_isIncomeRestricted_Path =
  '/api/web/v2/users/properties/isIncomeRestricted';

export const RentalManagerUserPropertyEditV2WebApiHandler_isIncomeRestricted = (
  postData: UserPropertyEditIsIncomeRestrictedV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditIsIncomeRestrictedV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_isIncomeRestricted_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_isRentersInsuranceRequired_Path =
  '/api/web/v2/users/properties/isRentersInsuranceRequired';

export const RentalManagerUserPropertyEditV2WebApiHandler_isRentersInsuranceRequired = (
  postData: UserPropertyEditIsRentersInsuranceRequiredV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyEditIsRentersInsuranceRequiredV2RequestDto,
    UserPropertyEditResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_isRentersInsuranceRequired_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_laundry_Path = '/api/web/v2/users/properties/laundry';

export const RentalManagerUserPropertyEditV2WebApiHandler_laundry = (
  postData: UserPropertyEditLaundryV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditLaundryV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_laundry_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_leaseDuration_Path =
  '/api/web/v2/users/properties/leaseDuration';

export const RentalManagerUserPropertyEditV2WebApiHandler_leaseDuration = (
  postData: UserPropertyEditLeaseDurationV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditLeaseDurationV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_leaseDuration_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_leaseTerms_Path = '/api/web/v2/users/properties/leaseTerms';

export const RentalManagerUserPropertyEditV2WebApiHandler_leaseTerms = (
  postData: UserPropertyEditLeaseTermsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditLeaseTermsV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_leaseTerms_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_modularListingProgress_Path =
  '/api/web/v2/users/properties/modularListingProgress';

export const RentalManagerUserPropertyEditV2WebApiHandler_modularListingProgress = (
  postData: UserPropertyEditModularListingProgressV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyEditModularListingProgressV2RequestDto,
    RentalManagerModularListingProgressV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_modularListingProgress_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_name_Path = '/api/web/v2/users/properties/name';

export const RentalManagerUserPropertyEditV2WebApiHandler_name = (
  postData: UserPropertyEditNameV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditNameV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_name_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_parkingDescription_Path =
  '/api/web/v2/users/properties/parkingDescription';

export const RentalManagerUserPropertyEditV2WebApiHandler_parkingDescription = (
  postData: UserPropertyEditParkingDescriptionV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditParkingDescriptionV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_parkingDescription_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_petPolicyDescription_Path =
  '/api/web/v2/users/properties/petPolicyDescription';

export const RentalManagerUserPropertyEditV2WebApiHandler_petPolicyDescription = (
  postData: UserPropertyEditPetPolicyDescriptionV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditPetPolicyDescriptionV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_petPolicyDescription_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_phone_Path = '/api/web/v2/users/properties/phone';

export const RentalManagerUserPropertyEditV2WebApiHandler_phone = (
  postData: UserPropertyEditPhoneV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditPhoneV2RequestDto, UserPropertyEditPhoneResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_phone_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_propertyType_Path =
  '/api/web/v2/users/properties/propertyType';

export const RentalManagerUserPropertyEditV2WebApiHandler_propertyType = (
  postData: UserPropertyEditPropertyTypeV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditPropertyTypeV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_propertyType_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_securityDeposit_Path =
  '/api/web/v2/users/properties/securityDeposit';

export const RentalManagerUserPropertyEditV2WebApiHandler_securityDeposit = (
  postData: UserPropertyEditSecurityDepositV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyEditSecurityDepositV2RequestDto,
    UserPropertyEditSecurityDepositResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_securityDeposit_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_setAsPropertyOnly_Path =
  '/api/web/v2/users/properties/setAsPropertyOnly';

export const RentalManagerUserPropertyEditV2WebApiHandler_setAsPropertyOnly = (
  postData: UserPropertyEditSetAsPropertyOnlyV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditSetAsPropertyOnlyV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_setAsPropertyOnly_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_unitsInBuilding_Path =
  '/api/web/v2/users/properties/unitsInBuilding';

export const RentalManagerUserPropertyEditV2WebApiHandler_unitsInBuilding = (
  postData: UserPropertyEditUnitsInBuildingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditUnitsInBuildingV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_unitsInBuilding_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_videoUrl_Path = '/api/web/v2/users/properties/videoUrl';

export const RentalManagerUserPropertyEditV2WebApiHandler_videoUrl = (
  postData: UserPropertyEditVideoUrlV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditVideoUrlV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_videoUrl_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyEditV2WebApiHandler_webSite_Path = '/api/web/v2/users/properties/webSite';

export const RentalManagerUserPropertyEditV2WebApiHandler_webSite = (
  postData: UserPropertyEditWebSiteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditWebSiteV2RequestDto, UserPropertyEditResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyEditV2WebApiHandler_webSite_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
